import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ThirdPartyLogisticsService } from 'src/app/services/third-party-logistics.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Companies, CreateConnection } from 'src/app/models/account.model';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
@Component({
  selector: 'app-create-app-popup',
  templateUrl: './create-app-popup.component.html',
  styleUrls: ["../new-connection.scss",'./create-app-popup.component.scss']
})
export class CreateAppPopupComponent implements OnInit,OnDestroy {
  @ViewChild("companyId", { read: MatAutocompleteTrigger }) companyId: MatAutocompleteTrigger;
  @Output() saved: EventEmitter<boolean> = new EventEmitter();
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  loading:boolean;
  isdisable:boolean=false;
  companies: Companies[];
  company: Companies[];
  filteredOptions: Observable<Companies[]>;
  isValidCompany:boolean=false;
  private destroy$ = new Subject<void>();

  public createAppForm: FormGroup = new FormGroup({
    Email: new FormControl(0, Validators.required),
    Password: new FormControl(null, Validators.required),
    CompanyName: new FormControl(null, Validators.required)
  });
  constructor(private thirdPartyLogistics: ThirdPartyLogisticsService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.getCompanies();
    window.addEventListener('scroll', this.scrollEvent, true);
     this.createAppForm.get("Email").setValue(JSON.parse(localStorage.getItem('User')).email);
     this.createAppForm.get("CompanyName").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((val:string)=>{
      const index = this.companies.findIndex((res)=>res.companyName === val);
      if(index !== -1){
        this.isValidCompany = true; 
      } else{
        this.isValidCompany = false; 
      }
     })
  }
  
  private _filter(value: string): Companies[] {
    const filterValue = value.toLowerCase();
    return this.companies.filter(option => option.companyName.toLowerCase().includes(filterValue));
  }

  connect3PL(){
    this.loading = true;
    this.company = this.companies.filter((res)=>res.companyName == this.createAppForm.controls.CompanyName.value);
    let payload: CreateConnection ={
      email: this.createAppForm.controls.Email.value,
      password: this.createAppForm.controls.Password.value,
      companyId: this.company[0].companyId
    }
    this.thirdPartyLogistics.CreateApp(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) =>{
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Connection added successfully.',
            action: 'Dismiss',
            type: 'success',
          },
        }
    );
      this.saved.emit();
    },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error,
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
     }
   });
  }

  getCompanies(){
    this.thirdPartyLogistics.GetCompanies().pipe(takeUntil(this.destroy$)).subscribe({
     next: (res : Companies[]) =>{
      this.companies = res;
      this.filteredOptions = this.createAppForm.get("CompanyName").valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value)),
      );
    },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error,
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
     }
   });
  }

  stopSpace(event){
    if (event.keyCode == 32) { 
      event.stopPropagation();
    }
  }

  scrollEvent = (event: any): void => {
    if(this.companyId.panelOpen)
      this.companyId.updatePosition();
  };
  
  onFocusOutEvent(event: any,trigger: MatAutocompleteTrigger){
     if(event.relatedTarget && event.relatedTarget?.nodeName.toLowerCase() !== "mat-option")
      trigger.closePanel();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
